import {fetchRpc} from './../rpcCall/index.js';
import type {GetTransactionDataConfig,TransactionDataParsed,RpcTransactionDataResponse} from './../../interfaces/index.js';
export function getTransactionDataParams(
  signature: string,
  config: GetTransactionDataConfig = { maxSupportedTransactionVersion: 0 }
) {
  return [signature, config] as const;
}
export async function getTransactionInfo(
  signature: string
): Promise<TransactionDataParsed | null> {
  return fetchRpc(
    'getTransaction',
    getTransactionDataParams(signature)
  );
}
export function normalizeRpcTransactionData(
  sigkey: string,
  response: RpcTransactionDataResponse
) {
  if (!response.value) return null;

  const { data, encoding, program, parsed, raw, space } =
    normalizeTransactionData(response.value.data) as any;

  return {
    sigkey,
    slot: response.context.slot,
    owner: response.value.owner,
    lamports: response.value.lamports,
    executable: response.value.executable,
    rent_epoch: response.value.rentEpoch,
    space,
    encoding,
    program,
    parsed,
    raw,
  };
}
export function isJsonParsedTransaction(
  data: unknown
): data is {
  program: string;
  parsed: unknown;
  space: number;
} {
  return (
    typeof data === 'object' &&
    data !== null &&
    'parsed' in data &&
    'program' in data
  );
}
export function normalizeTransactionData(data: any) {
  if (isJsonParsedTransaction(data)) {
    return {
      encoding: 'jsonParsed' as const,
      program: data.program,
      parsed: data.parsed,
      raw: null,
      space: data.space,
    };
  }

  // raw base64 account
  if (Array.isArray(data) && typeof data[0] === 'string') {
    return {
      encoding: data[1] ?? 'base64',
      program: null,
      parsed: null,
      raw: data[0],
      space: null,
    };
  }

  throw new Error('Unknown account data format');
}



